module.exports = __webpack_public_path__ + "static/assets/4b8df82554736ab85bb50a5abd86853f.gif";